import { FormVariants, FontWeight } from "./enums";
import { ThemeTextStyles } from "./textStyles";
export const ThemeForms = {
    [FormVariants.input]: {
        p: 0,
        px: "10",
        m: 0,
        pt: "0.15rem",
        height: "2.875rem",
        borderRadius: 2,
        borderColor: "grey.1",
        transition: "all 0.1s ease-in",
        variant: "text.label2",
        fontWeight: FontWeight.textRegular,
        bg: "white.0",
        ":focus": {
            outlineWidth: 1,
            outlineColor: "blue.0",
            outlineStyle: "solid",
            borderColor: "blue.0",
            "::placeholder": {
                opacity: 1
            },
            ":placeholder-shown::placeholder": {
                opacity: 1
            }
        },
        "::placeholder": {
            color: "grey.2",
            opacity: 1
        },
        ":placeholder-shown::placeholder": {
            opacity: 1
        },
        ":-webkit-autofill": {
            fontSize: `${ThemeTextStyles.label2.fontSize} !important`
        },
        ":-webkit-autofill:hover": {
            fontSize: `${ThemeTextStyles.label2.fontSize} !important`
        },
        ":-webkit-autofill::first-line": {
            fontSize: `${ThemeTextStyles.label2.fontSize} !important`
        },
        ":-webkit-autofill::first-line:hover": {
            fontSize: `${ThemeTextStyles.label2.fontSize} !important`
        }
    },
    [FormVariants.select]: {
        p: 0,
        px: 10,
        m: 0,
        pt: 12,
        height: "2.875rem",
        borderRadius: 2,
        borderColor: "grey.1",
        bg: "white.0",
        transition: "all 0.1s ease-in",
        variant: `text.label2`,
        ":focus": {
            outlineWidth: 1,
            outlineColor: "blue.0",
            outlineStyle: "solid",
            borderColor: "blue.0"
        }
    },
    [FormVariants.selectOutlineDark]: {
        p: 0,
        px: 10,
        m: 0,
        pt: 12,
        height: "2.875rem",
        borderRadius: 2,
        color: "grey.2",
        borderColor: "grey.2",
        bg: "transparent",
        transition: "all 0.1s ease-in",
        variant: "text.label2",
        ":focus": {
            outlineWidth: 1,
            outlineColor: "grey.2",
            outlineStyle: "solid",
            color: "grey.2",
            borderColor: "blue.0"
        },
        ":hover": {
            color: "white.0",
            borderColor: "white.0"
        }
    },
    [FormVariants.textarea]: {
        p: 0,
        px: "10",
        m: 0,
        pt: 24,
        minHeight: 64,
        height: "auto",
        borderRadius: 2,
        borderColor: "grey.1",
        transition: "all 0.1s ease-in",
        variant: "text.label2",
        bg: "white.0",
        ":focus": {
            outline: "none",
            borderColor: "blue.0",
            "::placeholder": {
                opacity: 1
            },
            ":placeholder-shown::placeholder": {
                opacity: 1
            }
        },
        "::placeholder": {
            color: "grey.2",
            opacity: 1
        },
        ":placeholder-shown::placeholder": {
            opacity: 0
        }
    },
    [FormVariants.label]: {
        width: "auto",
        color: "grey.1",
        variant: "text.label2",
        fontWeight: "labelRegular"
    },
    [FormVariants.radio]: {
        cursor: "pointer",
        bg: "white.0",
        color: "grey.1",
        "input:checked ~ &": {
            color: "blue.0"
        },
        "input:focus ~ &": {
            bg: "white.0"
        }
    },
    [FormVariants.checkbox]: {
        cursor: "pointer",
        borderRadius: 0,
        bg: "transparent",
        color: "grey.1",
        "input:checked ~ &": {
            color: "blue.0"
        },
        "input:focus ~ &": {
            bg: "transparent"
        }
    },
    [FormVariants.search]: {
        p: 0,
        px: "10",
        m: 0,
        pt: "0.15rem",
        height: "2.875rem",
        border: "none",
        variant: "text.label2",
        bg: "grey.4",
        ":focus": {
            outline: "none"
        },
        width: [370, 370, 470]
    }
};
//# sourceMappingURL=forms.js.map